import { Chart } from 'chart.js';

let detailChartsIdle: Promise<void> = Promise.resolve();
let indexChartsIdle: Promise<void> = Promise.resolve();

export const waitClientV2DetailChartsIdle = () => detailChartsIdle;

export const waitClientV2IndexChartsIdle = () => indexChartsIdle;

export const markClientV2DetailChartsDisposing = (work: Promise<void>) => {
  detailChartsIdle = work.then(() => undefined, () => undefined);
};

export const markClientV2IndexChartsDisposing = (work: Promise<void>) => {
  indexChartsIdle = work.then(() => undefined, () => undefined);
};

const waitFrames = (count = 2) => new Promise<void>((resolve) => {
  let left = count;
  const step = () => {
    if (left <= 0) {
      resolve();
      return;
    }
    left -= 1;
    requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
});

/** 路由切换兜底：销毁指定容器内 canvas 上仍注册的 Chart（避免 Animator 残留） */
export const destroyAllChartsUnderSelector = async (selector: string) => {
  const root = document.querySelector(selector);
  if (!root) return;
  const canvases = root.querySelectorAll('canvas');
  for (const node of canvases) {
    const canvas = node as HTMLCanvasElement;
    const chart = Chart.getChart(canvas);
    if (!chart) continue;
    try {
      chart.options.events = [];
    } catch {
      /* ignore */
    }
    try {
      (chart.options as { animation?: false }).animation = false;
      chart.data?.datasets?.forEach((ds) => {
        const row = ds as { animation?: false; fill?: boolean };
        row.animation = false;
        row.fill = false;
      });
    } catch {
      /* ignore */
    }
    try {
      chart.stop();
    } catch {
      /* ignore */
    }
    await waitFrames(1);
    try {
      if (chart.ctx) chart.destroy();
    } catch {
      /* ignore */
    }
    const orphan = Chart.getChart(canvas);
    if (orphan) {
      try {
        orphan.destroy();
      } catch {
        /* ignore */
      }
    }
  }
  await waitFrames(2);
};
